import React, { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../firebase';
import { useTranslatedText } from '../i18n/useTranslatedText.js';
import './Auth.css';

const GoogleSignupComplete = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [age, setAge] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const loadingText = useTranslatedText('Yükleniyor...');
  const titleText = useTranslatedText('Profilinizi Tamamlayın');
  const usernamePlaceholder = useTranslatedText('Kullanıcı Adı');
  const agePlaceholder = useTranslatedText('Yaş');
  const saveProfileText = useTranslatedText('Profili Kaydet');
  const loadErrorText = useTranslatedText('Kullanıcı bilgileri yüklenemedi.');
  const fillAllFieldsText = useTranslatedText('Lütfen tüm alanları doldurun.');
  const updateErrorPrefixText = useTranslatedText('Profil güncellenemedi:');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate('/giriş-yap');
        return;
      }

      try {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          if (userData.username && userData.age) {
            navigate('/');
            return;
          }
        }
      } catch {
        setError(loadErrorText);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, [loadErrorText, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !age.trim()) {
      setError(fillAllFieldsText);
      return;
    }

    try {
      const user = auth.currentUser;
      if (!user) throw new Error('No authenticated user');

      await setDoc(
        doc(db, 'users', user.uid),
        {
          username: username.trim(),
          age: parseInt(age, 10),
          emailVerified: true,
        },
        { merge: true }
      );
      navigate('/');
    } catch (err) {
      setError(`${updateErrorPrefixText} ${err?.message || String(err)}`);
    }
  };

  if (loading) {
    return (
      <div className="auth-container">
        <div className="loading-spinner">{loadingText}</div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <h2>{titleText}</h2>
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder={usernamePlaceholder}
          required
        />
        <input
          type="number"
          value={age}
          onChange={(e) => setAge(e.target.value)}
          placeholder={agePlaceholder}
          required
          min="13"
          max="120"
        />
        <button type="submit" className="Confirm">
          {saveProfileText}
        </button>
      </form>
    </div>
  );
};

export default GoogleSignupComplete;
